(() => {
  const update = (badge, variantId) => {
    const labels = badge.querySelector('[data-leks-stock-labels]')?.dataset;
    if (!labels) return;
    const data = Array.from(badge.querySelectorAll('[data-leks-stock-variant]')).find(el => el.dataset.leksStockVariant === String(variantId))?.dataset;
    let key = 'selectVariant';
    let state = 'unknown';
    if (data) {
      if (data.available !== 'true') key = 'unavailable';
      else if (data.tracked === 'true' && Number(data.quantity) > 0) { key = 'inStock'; state = 'in'; }
      else if (data.tracked === 'true' || data.orderTag === 'true') { key = 'order'; state = 'order'; }
      else key = 'available';
    }
    badge.classList.remove('leks-stock--in', 'leks-stock--order', 'leks-stock--unknown');
    badge.classList.add(`leks-stock--${state}`);
    badge.querySelector('[data-leks-stock-text]').textContent = labels[key];
  };
  document.addEventListener('variant:change', event => {
    const id = event.detail?.variant?.id;
    if (!id) return;
    document.querySelectorAll('[data-leks-stock]').forEach(badge => {
      if (Array.from(badge.querySelectorAll('[data-leks-stock-variant]')).some(el => el.dataset.leksStockVariant === String(id))) update(badge, id);
    });
  });
  document.addEventListener('variantChange', event => {
    if (event.detail?.variant) return;
    event.target.querySelectorAll?.('[data-leks-stock]').forEach(badge => update(badge, null));
  }, true);
})();
